__turbopack_context__.v({
  "iconWrapper": "icon-tooltip-module-scss-module__diHE8q__iconWrapper",
  "u-animation-bounce": "icon-tooltip-module-scss-module__diHE8q__u-animation-bounce",
});
